export interface ResponseStatusMessage {
  statusCode: number;
  message: string;
}

export const RESPONSE_OK = 200;

export const DEFAULT_ERROR_MESSAGE = "Request could not be performed.";

export const NO_CONTENT = <ResponseStatusMessage>{
  statusCode: 204,
  message:
    "We're sorry, we are unable to locate this route on any commercial aircraft.",
};

export const MULTIPLE_CONTENT = <ResponseStatusMessage>{
  statusCode: 207,
  message:
    "It looks like the airline in question has used this flight number on multiple routes. Please enter in the route details manually.",
};

export const BAD_REQUEST = <ResponseStatusMessage>{
  statusCode: 400,
  message: "Invalid input: Please ensure all input fields have been populated.",
};

export const NOT_FOUND = <ResponseStatusMessage>{
  statusCode: 404,
  message:
    "Flight number does not exist. Please enter in the route details manually.",
};

export const TRIAL_EXCEEDED = <ResponseStatusMessage>{
  statusCode: 429,
  message: "Trial usage exceeded",
};

export const SERVER_ERROR = <ResponseStatusMessage>{
  statusCode: 500,
  message: "Looks like we have hit some turbulence! Please try again soon.",
};
export const ERROR_RESPONSES = [
  NO_CONTENT,
  MULTIPLE_CONTENT,
  BAD_REQUEST,
  TRIAL_EXCEEDED,
  NOT_FOUND,
  SERVER_ERROR,
];
